<h2 mat-dialog-title>
    {{ a_id ? 'Update Artist' : 'Add Artist' }}
</h2>

<form [formGroup]="ArtistForm" (ngSubmit)="onFormSubmit()">

    <mat-dialog-content class="content">

        <div class="row mb-4">
            <div class="col-9">
                <mat-label>Select Image</mat-label>
                <div class="input-group">
                    <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                        id="exampleInputFile" (change)="previewpimage(file.files)">
                </div>
            </div>

            <div class="col-3">
                <div *ngIf="!isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/artist/{{this.imagePath}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
                <div *ngIf="isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/artist/{{image_name}}"
                        style="width: 80px;height: 80px;border-radius: 10px;">
                </div>
            </div>


        </div>

        <!-- Artist Name -->
        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Artist Name</mat-label>
                <input matInput placeholder="Enter Artist Name" [ngModel]="artist" formControlName="artist">
            </mat-form-field>
        </div>

        <!-- Role -->
        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Role</mat-label>
                <input matInput placeholder="Ex. Singer, Dancer, Speaker" [ngModel]="role" formControlName="role">
            </mat-form-field>
        </div>

        <!-- Description -->
        <div class="column">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Description</mat-label>
                <textarea matInput placeholder="Enter Description" rows="3" [ngModel]="description"
                    formControlName="description">
        </textarea>
            </mat-form-field>
        </div>


    </mat-dialog-content>

    <mat-dialog-actions class="action" align="end">
        <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">
            Cancel
        </button>

        <button mat-raised-button type="submit" color="primary">
            {{ a_id ? 'Update' : 'Add' }}
        </button>
    </mat-dialog-actions>

</form>